export default __webpack_public_path__ + "static/media/plus.3322c83d.svg";